export const landing = {
  appName: "Koru",
  catchphrase: "日本文化を一緒に発見しよう",
  loginWithEmail: "メールアドレスでログイン",
  register: "新規登録",
  termsAgreementPrefix: "",
  termsAgreementMiddle: "と",
  termsAgreementSuffix: "上記に同意します",
  termsOfService: "利用規約",
  privacyPolicy: "プライバシーポリシー",
} as const;
